<template>
  <div
    id="providers"
    class="row"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        lg="9"
      >
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          @submit.prevent="reset"
          @keydown="form.onKeydown($event)"
        >
          <v-container grid-list-xl>
            <form-toolbar
              :title="title"
              :loading="form.busy"
              @save="save"
              @cancel="cancel"
            />
            <v-layout
              :id="ref"
              class="wrap justify-space-around form-body"
            >
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="form.name"
                  :rules="[rules.required, rules.maximo100]"
                  :maxlength="100"
                  label="Nombre"
                  placeholder="Licencia Tipo Seis"
                  required
                  @change="check"
                />
              </v-col>

              <v-col
                cols="12"
                md="12"
              >
                <v-textarea
                  clearable
                  counter
                  v-model="form.description"
                  :rules="[rules.required, rules.maximo]"
                  maxlength=300
                  label="Descripción"
                  placeholder="Licnecia que permite..."
                  required
                />
              </v-col>
            </v-layout>
          </v-container>
        </v-form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import Form from 'vform';
  import FormToolbar from '~/components/Form/Toolbar';

  export default {
    metaInfo() {
      return { title: this.$t('typeLicenses') };
    },
    components: {
      FormToolbar,
    },
    props: {
      id: { default: null },
    },
    data: () => ({
      form: new Form({
        id: null,
        name: '',
        description: null,
      }),
      errores: null,
      valid: false,
      rules: {
        required: (v) => !!v || 'El campo es requerido.',
        maximo: (v) => (v !== null && v.length) <= 300 || 'Máximo 300 caracteres',
        maximo100: (v) => (v !== null && v.length) <= 100 || 'Máximo 100 caracteres',
      },
      buttons: [
        {
          icon: 'mdi-content-save',
          name: 'Guardar',
        },
        {
          icon: 'mdi-close',
          name: 'Cancelar',
        },
      ],
      title: 'Nuevo Usuario',
      apiURL: '/api/catalogs/type_licenses',
      method: 'POST',
    }),
    computed: {
      ref() { return this.form.id; },
      items() {
        const items = [];
        return items;
      },
    },
    async mounted() {
      this.reset();
      this.URL = `${this.apiURL}/${this.id}`;
      if (this.id) {
        window.axios.get(`${this.apiURL}/${this.id}`)
        .then((result) => {
          Object.assign(this.form, result.data[0]);
          this.URL = `${this.apiURL}/${this.id}/update`;
          this.method = 'PUT';
          this.title = 'Editar Tipo Licencia';
        });
      } else {
          this.URL = `${this.apiURL}/store`;
          this.title = 'Nuevo Tipo Licencia';
      }
    },
    methods: {
      validate() {
        if (this.$refs.form.validate()) {
          this.snackbar = true;
          this.form.busy = true;
          this.store();
        }
      },
      store() {
        window.axios({
          method: this.method,
          url: this.URL,
          data: this.form,
        })
        .then(() => {
          this.$router.go(-1);
        }).catch(() => {
          this.form.busy = false;
        });
      },
      save() {
        this.validate(); // someValue
      },
      cancel() {
        this.$router.go(-1); // someValue
      },
      reset() {
        this.form = new Form({
          id: null,
          name: null,
          description: null,
        });
        this.resetValidation();
        this.title = 'Nuevo Tipo Licencia';
        this.disabled = false;
        this.URL = `${this.apiURL}/store`;
        this.method = 'POST';
      },
      resetValidation() {
        this.$refs.form.resetValidation();
      },
      check(value) {
        const urlCheck = `${this.apiURL}/check`;
        if (value !== null) {
          window.axios({
            method: 'POST',
            url: urlCheck,
            data: { name: value },
          }).then((response) => {
            if (response.data.type === 'error') {
              this.form.name = null;
              this.$store.dispatch('notifications/show', {
                message: response.data.message,
                type: response.data.type,
              });
            }
          });
        }
      },
    },
  };

</script>
